
import { v4 as uuidv4 } from 'uuid'
import getCookieDomain from '~/utils/getCookieDomains'

export default {
  mounted() {
    let userId = this.$cookies.get('sentry_uuid')
    if (!userId) {
      userId = uuidv4()
      const cookieDomain = getCookieDomain(process.env.BASE_URL)
      this.$cookies.set('sentry_uuid', userId, {
        domain: cookieDomain,
        path: '/',
        secure: window.location.protocol === 'https:',
        sameSite: 'lax',
      })
    }

    this.$sentry.setUser({
      id: userId,
      ip_address: '{{auto}}',
    })

    this.$sentry.setTag('locale', this.$i18n.locale)
    this.$sentry.setTag('route', this.$route.name)
    this.$sentry.setTag('environment', process.env.ENVIROMENT || 'development')
    this.$sentry.startSession()
  },
}
